import { color, fontSize } from "@xingternal/360-styles/helpers"
import { onlyfyFullTheme, xingTheme } from "@xingternal/rebranding-adapter"

export const styles = {
  "@global": {
    ".DatePicker.DayPicker .DayPicker-Day": {
      outline: "none",
      fontSize: fontSize("fz13"),
    },
    ".DatePicker.DayPicker .DayPicker-Day--today:not(.DayPicker-Day--selected):not(.DayPicker-Day--outside)":
      {
        background: color("gray-10"),
        color: color("gray-80"),
        borderRadius: 4,
      },
    ".DatePicker.DayPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)":
      {
        borderRadius: 0,
      },
    ".DatePicker.DayPicker .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside)":
      {
        backgroundColor: `rgba(0, 144, 144, 0.2)`,
        color: color("gray-80"),
      },
    ".DatePicker.DayPicker.DatePickerRebranded .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside)":
      {
        backgroundColor: `${xingTheme.colors.grey50}`,
        color: color("gray-80"),
      },
    ".DatePicker.DayPicker .DayPicker-Day--start:not(.DayPicker-Day--outside)":
      {
        background: onlyfyFullTheme.colors.blue8,
        borderTopLeftRadius: "4px !important",
        borderBottomLeftRadius: "4px !important",
      },
    ".DatePicker.DayPicker.DatePickerRebranded .DayPicker-Day--start:not(.DayPicker-Day--outside)":
      {
        background: `${xingTheme.colors.grey800}`,
        borderTopLeftRadius: "4px !important",
        borderBottomLeftRadius: "4px !important",
      },
    ".DatePicker.DayPicker .DayPicker-Day--end:not(.DayPicker-Day--outside)": {
      background: onlyfyFullTheme.colors.blue8,
      borderTopRightRadius: "4px !important",
      borderBottomRightRadius: "4px !important",
    },
    ".DatePicker.DayPicker.DatePickerRebranded .DayPicker-Day--end:not(.DayPicker-Day--outside)":
      {
        background: `${xingTheme.colors.grey800}`,
        borderTopRightRadius: "4px !important",
        borderBottomRightRadius: "4px !important",
      },
    ".DatePicker.DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover":
      {
        background: color("gray-10"),
        borderRadius: 4,
      },
    ".DatePicker.DayPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover":
      {
        background: onlyfyFullTheme.colors.blue8,
        color: "white",
      },
    ".DatePicker.DayPicker.DatePickerRebranded .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover":
      {
        background: `${xingTheme.colors.grey800}`,
        color: "white",
      },
    ".DatePicker.DayPicker .DayPicker-Day--highlight:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)":
      {
        boxShadow: `inset 0 0 0 2px ${onlyfyFullTheme.colors.blue8}`,
        color: onlyfyFullTheme.colors.blue8,
        background: "white",
      },
    ".DatePicker.DayPicker .DayPicker-wrapper, .DatePicker.DayPicker .DayPicker-wrapper:focus":
      {
        paddingBottom: 0,
        outline: 0,
      },
    ".DatePicker.DayPicker .DayPicker-Months": { flexWrap: "nowrap" },
    ".DatePicker.DayPicker .DayPicker-Month": { margin: 0, minWidth: 220 },
    ".DatePicker.DayPicker .DayPicker-Month + .DayPicker-Month": {
      marginLeft: 16,
    },
    ".DatePicker.DayPicker .DayPicker-Caption": { textAlign: "center" },
    ".DatePicker.DayPicker .DayPicker-Caption > div": {
      fontSize: "15px",
      fontWeight: 700,
    },
  },
}

export const navbarStyles = {
  monthsNav: { composes: "relative" },
  monthsNavLink: { composes: "absolute t0 cursor-pointer onlyfy-link" },
  monthsPrev: { composes: "$monthsNavLink l0" },
  monthsNext: { composes: "$monthsNavLink r0" },
}

export const weekdayStyles = {
  weekday: {
    composes: "gray-50 tal fz13 p8",
    display: "table-cell",
  },
  workday: { composes: "bold", color: color("gray-80") },
}
